// src/reducers/streamSongReducer.js

import { getUserId } from "../constants/function";

const initialState = {
  index: -1,
  songs: [],
  pos: 0,
  track: null,     // We'll store the Agora track object here
  timeStamp: null,
  vol: 25,
};

export default function streamSongReducer(state = initialState, action) {
  switch (action.type) {
    case "START_SONG_STREAM": {
      // Filter songs if needed
      const userId = getUserId();
      const rawSongs = action.payload.songs || [];
      const filtered = rawSongs.filter((s) =>
        s?.uploader?._id === userId ||
        (s?.uploader?._id !== userId && s.private && s?.uploader?.isSubscribed) ||
        (s?.uploader?._id !== userId && !s.private)
      );

      const volume = action.payload.vol ?? state.vol;

      return {
        ...state,
        index: action.payload.index,
        songs: filtered,
        pos: action.payload.pos || 0,
        track: action.payload.track || null,
        timeStamp: action.payload.timeStamp || Date.now(),
        vol: volume,
      };
    }

    case "END_SONG_STREAM":
      return {
        ...state,
        index: -1,
        songs: [],
        pos: 0,
        track: null,
      };

    default:
      return state;
  }
}
